<template>
    <div class="form-view password-modal">
        <template v-if="!showFeedback">
            <div class="modal-header">
                <h2 class="text-center">Glemt adgangskode</h2>
            </div>

            <div class="form">
                <div class="grid-x">
                    <div class="banner-lock">
                        <icon class="large-svg fill-white" name="locked" />
                    </div>
                </div>
            </div>
            <h6>Hvis du er oprettet som bruger, vil du modtage en e-mail med et nyt kodeord</h6>
        </template>
        <template v-if="!showFeedback">
            <div class="form">
                <div class="grid-x">
                    <div class="cell small-1 medium-1 large-1 flexbox-justify-content-center">
                        <icon class="small-svg fill-dark-gray" name="envelope" />
                    </div>
                    <div class="cell small-3 medium-3 large-3 flexbox align-items">
                        <p class="custom-modal-text-alignment">E-mail</p>
                    </div>
                    <div class="cell auto">
                        <email-validation :newUser="true" :autofocus="true" v-model="data" @validateEmail="validEmailResult" />
                    </div>
                </div>
            </div>
        </template>
        <template v-else class="email-feedback">
            <div class="grid-x flexbox-justify-content-center" style="height: 360px;">
                <icon name="paper-plane" class="email-feedback-svg fill-feedback" />
            </div>
            <div class="grid-x flexbox-justify-content-center">
                <h3>
                    E-mailen er nu blevet sendt til {{ data }}
                </h3>
            </div>
        </template>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" :disabled="!validEmail || !data" v-if="!showFeedback" @click="changePassword()">Send e-mail</button>
                <button type="button" class="button-naked" v-if="!showFeedback" @click="closeModal()">Fortryd</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import emailValidation from './../../shared/email/email-validation.vue'

export default {
    name: 'login-modal-forgotpassword',
    props: [
        'data'
    ],
    data () {
        return {
            validEmail: true,
            showFeedback: false
        }
    },
    components: {
        'email-validation': emailValidation
    },
    methods: {
        ...mapActions({
            setNewPasswordAsync: 'setNewPasswordAsync'
        }),
        closeModal () {
            this.$emit('close')
        },
        changePassword () {
            if (this.validEmail) {
                new Promise((resolve, reject) => {
                    resolve(this.setNewPasswordAsync(this.data))
                }).then(() => {
                    this.showFeedback = true
                    setTimeout(() => {
                        this.$emit('close')
                    }, 3000)
                })
            }
        },
        validEmailResult (result) {
            this.validEmail = result
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/login/login-modal-forgotpassword.vue